import { createAction, handleActions } from '@housinganywhere/safe-redux';
import { getMutableState, getImmutableState } from './helpers/state';

const Actions = {
  CLEAR: '@redux-conn/CLEAR',
  BEGIN_GLOBAL_LOAD: '@redux-conn/BEGIN_GLOBAL_LOAD',
  END_GLOBAL_LOAD: '@redux-conn/END_GLOBAL_LOAD',
  LOAD: '@redux-conn/LOAD',
  LOAD_SUCCESS: '@redux-conn/LOAD_SUCCESS',
  LOAD_FAIL: '@redux-conn/LOAD_FAIL',
};

export const clearKey = () => createAction(Actions.CLEAR);
export const beginGlobalLoad = () => createAction(Actions.BEGIN_GLOBAL_LOAD);
export const endGlobalLoad = () => createAction(Actions.END_GLOBAL_LOAD);
export const load = key => createAction(Actions.LOAD, { key });
export const loadSuccess = (key, data) =>
  createAction(Actions.LOAD_SUCCESS, { key, data });
export const loadFail = (key, error) =>
  createAction(Actions.LOAD_FAIL, { key, error });

const initialState = {
  loaded: false,
  loadState: {},
};

export const reducer = handleActions(
  {
    [Actions.BEGIN_GLOBAL_LOAD]: state => ({
      ...state,
      loaded: false,
    }),

    [Actions.END_GLOBAL_LOAD]: state => ({
      ...state,
      loaded: true,
    }),

    [Actions.LOAD]: (state, { payload }) => ({
      ...state,
      loadState: {
        ...state.loadState,
        [payload.key]: {
          loading: true,
          loaded: false,
        },
      },
    }),

    [Actions.LOAD_SUCCESS]: (state, { payload: { key, data } }) => ({
      ...state,
      loadState: {
        ...state.loadState,
        [key]: {
          loading: false,
          loaded: true,
          error: null,
        },
      },
      [key]: data,
    }),

    [Actions.LOAD_FAIL]: (state, { payload: { key, error } }) => ({
      ...state,
      loadState: {
        ...state.loadState,
        [key]: {
          loading: false,
          loaded: false,
          error,
        },
      },
    }),

    [Actions.CLEAR]: (state, { payload }) => ({
      ...state,
      loadState: {
        ...state.loadState,
        [payload]: {
          loading: false,
          loaded: false,
          error: null,
        },
      },
      [payload]: null,
    }),
  },
  initialState,
);

export const immutableReducer = function wrapReducer(immutableState, action) {
  // We need to convert immutable state to mutable state before our reducer can act upon it
  let mutableState;

  if (immutableState === undefined) {
    // if state is undefined (no initial state yet) then we can't convert it, so let the
    // reducer set the initial state for us
    mutableState = immutableState;
  } else {
    // Convert immutable state to mutable state so our reducer will accept it
    mutableState = getMutableState(immutableState);
  }

  // Run the reducer and then re-convert the mutable output state back to immutable state
  return getImmutableState(reducer(mutableState, action));
};
